import React, { useEffect, useState } from "react";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

const OPTIONS = ["A", "B", "C", "D"];

// The OMR answer-sheet popup. Two modes:
//   • edit (default)  — fill the answer key; has Clear all + Save.
//   • readOnly=true   — preview a saved sheet (e.g. dashboard "View OMR");
//                       bubbles are locked and the footer is just Close.
// Design-only — answers live in local state.
export default function OmrSheetModal({
  open,
  title,
  count,
  initialAnswers,
  readOnly = false,
  onClose,
  onSave,
}) {
  const [answers, setAnswers] = useState(initialAnswers || {});

  // Re-seed when (re)opened so a preview shows the right paper's answers and a
  // fresh fill starts empty. initialAnswers must be a stable ref (see Dashboard).
  useEffect(() => {
    if (open) setAnswers(initialAnswers || {});
  }, [open, initialAnswers]);

  if (!open) return null;

  const total = Math.max(0, parseInt(count, 10) || 0);
  const answered = Object.keys(answers).length;

  const select = (q, opt) => {
    if (readOnly) return;
    setAnswers((prev) => ({ ...prev, [q]: opt }));
  };
  const clearAll = () => setAnswers({});

  return (
    <div className="domr-overlay" onClick={onClose}>
      <div className="domr-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="domr-sheet-head">
          <div>
            <h2>{title || "OMR Sheet"}</h2>
            <div className="cnt">
              {answered} - {total} answered
            </div>
          </div>
          <div className="right">
            {readOnly ? (
              <button className="domr-btn domr-btn-ghost" onClick={onClose}>
                <Close style={{ fontSize: 18 }} /> Close
              </button>
            ) : (
              <>
                <button className="domr-clear-all" onClick={clearAll}>
                  Clear all
                </button>
                <button
                  className="domr-btn domr-btn-primary"
                  onClick={() => onSave && onSave(answers)}
                >
                  <Check style={{ fontSize: 18 }} /> Save
                </button>
              </>
            )}
          </div>
        </div>

        <div className={"domr-omr-grid" + (readOnly ? " view" : "")}>
          {Array.from({ length: total }, (_, i) => {
            const q = i + 1;
            return (
              <div className="domr-q" key={q}>
                <span className="domr-q-no">{q}</span>
                <span className="domr-bubbles">
                  {OPTIONS.map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={
                        "domr-bubble" + (answers[q] === opt ? " sel" : "")
                      }
                      onClick={() => select(q, opt)}
                      style={readOnly ? { cursor: "default" } : undefined}
                    >
                      {opt}
                    </button>
                  ))}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
